module.exports = __webpack_public_path__ + "img/rx.7f966d55.svg";